import { cleanParams } from '../../utils';

export const getMappedParams = values => {
  const params = {
    // sellerAccountId: values.accountsQueryString,// this is not selected as a regular filter, it is set in the special account select bar
    status: values.statuses.toJSON(),
    sourceMarketplace: values.sourceId,
    timeLeftUntilHours: values.timeLeft,
    outOfStockOverDays: values.outOfStockDays,
    salesNumberFrom: values.numberOfOrdersFrom,
    salesNumberTo: values.numberOfOrdersTo,
    competitorCountFrom: values.numberOfCompetitorsFrom,
    competitorCountTo: values.numberOfCompetitorsTo,
    listDateFrom: values.listDateFrom,
    listDateTo: values.listDateTo,
    withoutSalesOverDays: values.daysWithoutSale,
    destinationPriceFrom: values.destinationPriceFrom,
    destinationPriceTo: values.destinationPriceTo,
    sourcePriceFrom: values.sourcePriceFrom,
    sourcePriceTo: values.sourcePriceTo,
    profitFrom: values.profitFrom,
    profitTo: values.profitTo,
    profitInPercents: values.profit,
    hitCountFrom: values.itemViewsFrom,
    hitCountTo: values.itemViewsTo,
    watchCountFrom: values.itemWatchersFrom,
    watchCountTo: values.itemWatchersTo,
    template: values.template,
    discoveryId: values.discoveryId,
    notMonitoring: values.notMonitoring,
    offerType:values.offerType,
  };
  return cleanParams(params);
};
